@if (
  {
    frameLength: frameLength$ | async,
    daysRange: daysRange$ | async,
    publicHolidaysRegion: publicHolidaysRegion$ | async,
    resourcesColumnWidthPx: resourcesColumnWidthPx$ | async,
    mouseOverRowIndex: modalInteractionService.hoveredRowIndex$ | async,
    selectedRowIndex: modalInteractionService.selectedRowIndex,
  };
  as timelineData
) {
  <div
    *cdkVirtualFor="
      let user of userTimelinesInfo;
      let i = index;
      trackBy: trackById;
      count as c;
      templateCacheSize: 10
    "
  >
    @if (
      {
        determinedUserData:
          user
          | timelineFilterUserSkippedActivities
          | timelineModalOverlapLevels: { renderRadioInput, defaultRowHeight },
        isHovered:
          i === timelineData.mouseOverRowIndex ||
          i === timelineData.selectedRowIndex,
      };
      as data
    ) {
      <div
        class="d-flex"
        (mouseenter)="modalInteractionService.setHoveredRowIndex(i)"
      >
        <div class="sticky left-container" [class.hover]="data.isHovered">
          <div
            id="left-block"
            [style.width.px]="timelineData.resourcesColumnWidthPx"
          >
            <wilson-user-timeline-info-radio-group
              [index]="i"
              [user]="user"
            ></wilson-user-timeline-info-radio-group>
          </div>
        </div>
        <div
          class="timeline-container"
          [style.width.px]="timelineData.frameLength"
        >
          <div class="timeline-block">
            <div class="items-container">
              <div class="item" [class.hover]="data.isHovered">
                <wilson-timeline-modal-user-view
                  [user]="user"
                  [userIndex]="i"
                  [userData]="{ rows: data.determinedUserData }"
                  [mouseOverRowIndex]="timelineData.mouseOverRowIndex"
                >
                </wilson-timeline-modal-user-view>
              </div>
            </div>
            <wilson-gantt-chart-day-demarcator
              [daysRange]="timelineData.daysRange"
              [holidayRegions]="timelineData.publicHolidaysRegion"
              [isHovered]="data.isHovered"
              [panelWidth]="timelineData.frameLength"
              [interval]="visibleDaysRange$ | async"
            ></wilson-gantt-chart-day-demarcator>
          </div>
        </div>
      </div>
    }
  </div>
}
